// extracted by mini-css-extract-plugin
module.exports = {"Intro":"Book_Intro__2ygOG","focusLine":"Book_focusLine__3b5lI","description":"Book_description__2ttz8"};